export const login = {
    "login_title_login": "登录",
    "login_title_register": "创建账号",
    "login_title_reset": "重置密码",
    "login_field_username": "用户名",
    "login_field_email": "邮箱",
    "login_field_register_coder": "邀请码",
    "login_placeholder_register_coder": "输入邀请码",
    "login_error_invalid_register_coder": "请输入邀请码",
    "login_field_verification_code": "验证码",
    "login_field_password": "密码",
    "login_field_confirm_password": "确认密码",
    "login_placeholder_username": "请输入用户名",
    "login_placeholder_email": "请输入邮箱",
    "login_placeholder_verification_code": "请输入验证码",
    "login_placeholder_password": "请输入密码",
    "login_placeholder_confirm_password": "请再次输入密码",
    "login_action_login": "登录",
    "login_action_register": "注册",
    "login_action_reset": "重置密码",
    "login_action_get_code": "获取验证码",
    "login_link_forgot_password": "忘记密码？",
    "login_link_go_register": "去注册",
    "login_error_no_email": "请输入邮箱",
    "login_error_code_failed": "发送验证码失败",
    "login_error_username_required": "用户名为必填项",
    "login_error_invalid_email": "邮箱格式不正确",
    "login_error_verification_code_required": "验证码为必填项",
    "login_error_password_required": "请输入密码",
    "login_error_confirm_password": "请确认密码",
    "login_error_password_mismatch": "两次输入的密码不一致",
    "login_error_general": "发生错误",
    "login_success_code_sent": "验证码已发送",
    "login_success_registered": "注册成功",
    "login_success_reset": "密码重置成功",
    "login_countdown": "秒",
    "reset_init_password_title": "密码重置",
    "reset_init_password_field_new_password": "新密码",
    "reset_init_password_field_confirm_password": "确认新密码",
    "reset_init_password_field_email": "邮箱地址",
    "reset_init_password_field_email_code": "验证码",
    "reset_init_password_placeholder_new_password": "请输入新密码",
    "reset_init_password_placeholder_confirm_password": "请再次输入新密码",
    "reset_init_password_placeholder_email": "请输入邮箱地址",
    "reset_init_password_placeholder_email_code": "请输入邮箱验证码",
    "reset_init_password_error_new_password_required": "请输入新密码",
    "reset_init_password_error_confirm_password_required": "请再次输入新密码",
    "reset_init_password_error_password_mismatch": "两次输入的密码不一致",
    "reset_init_password_error_email_required": "请输入邮箱地址",
    "reset_init_password_error_email_invalid": "请输入有效的邮箱地址",
    "reset_init_password_error_email_code_required": "请输入验证码",
    "reset_init_password_error_email_code_length": "验证码应为6位数字",
    "reset_init_password_action_reset": "重置密码",
    "reset_init_password_action_send_email": "发送验证邮件",
    "reset_init_password_countdown_wait": "请等待 {{seconds}} 秒",
    "reset_init_password_error_password_mismatch_msg": "两次输入的密码不一致",
    "reset_init_password_success": "密码重置成功",
    "reset_init_password_error_failed": "密码重置失败",
    "reset_init_password_error_get_user_failed": "获取用户信息失败",
    "reset_init_password_error_email_invalid_msg": "请输入有效的邮箱地址",
    "reset_init_password_success_email_sent": "重置邮件发送成功，请查收邮件",
    "reset_init_password_error_email_send_failed": "发送邮件失败"
};
